module.exports = __webpack_public_path__ + "static/media/031.62ab2aa9.jpg";